import { render, staticRenderFns } from "./WxNotice.vue?vue&type=template&id=694f153a&scoped=true"
import script from "./WxNotice.vue?vue&type=script&lang=js"
export * from "./WxNotice.vue?vue&type=script&lang=js"
import style0 from "./WxNotice.vue?vue&type=style&index=0&id=694f153a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694f153a",
  null
  
)

export default component.exports